import { FiHome, FiBox, FiFolder, FiUsers } from 'react-icons/fi';

/**
 * Fuente única de la navegación administrativa: la usan AdminSidebar,
 * AdminMobileDrawer y AdminTopbar (para resolver el título de la sección
 * actual), así que las cuatro rutas reales viven en un solo lugar.
 */
const ADMIN_NAV_ITEMS = [
  { label: 'Resumen', href: '/admin/index', icon: FiHome },
  { label: 'Productos', href: '/admin/products', icon: FiBox },
  { label: 'Proyectos', href: '/admin/projects', icon: FiFolder },
  { label: 'Usuarios', href: '/admin/users', icon: FiUsers },
];

export default ADMIN_NAV_ITEMS;
